import script from "./QuizReviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizReviewPage.vue?vue&type=script&setup=true&lang=js"

import "./QuizReviewPage.vue?vue&type=style&index=0&id=d8788d8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8788d8e"]])

export default __exports__